import { FlexGrid, Typography, Box } from '@telus-uds/components-web'

// Rendered inline by the page wrapper when a Contentful Timeline preview request fails.
// Only reachable in non-prod (the prod gate in resolveTimelinePreviewFromCtx keeps the
// timeline preview path off in production), so this never reaches end users.
export function TimelinePreviewError() {
  return (
    <FlexGrid>
      <Box bottom={4}>
        <Box vertical={3}>
          <Typography block variant={{ size: 'h1' }}>
            Invalid Timeline preview URL
          </Typography>
        </Box>
        <Typography block variant={{ size: 'h4' }}>
          This Contentful Timeline preview link is invalid or has expired. Generate a new preview link from Contentful.
        </Typography>
      </Box>
    </FlexGrid>
  )
}
